document.addEventListener('DOMContentLoaded', () => {

  const repairDataElement = document.getElementById('repair-data');
  if (!repairDataElement) {
    console.error('Repair Finder ERROR: Data script element (#repair-data) not found!');
    return;
  }

  let allDevicesList;
  try {
    allDevicesList = JSON.parse(repairDataElement.textContent);
  } catch (e) {
    console.error('Repair Finder ERROR: Failed to parse JSON data.', e);
    return;
  }

  if (!Array.isArray(allDevicesList)) {
    console.error('Repair Finder ERROR: Parsed data is NOT an array. Halting execution.', allDevicesList);
    return;
  }

  // Structure des données pour cascading dropdowns
  const devices = {};
  const deviceUrls = {}; // Stockage des URLs
  const deviceHandles = {}; // Stockage des handles

  allDevicesList.forEach(device => {
    if (!devices[device.type]) {
      devices[device.type] = {};
    }
    if (!devices[device.type][device.brand]) {
      devices[device.type][device.brand] = [];
    }
    if (!devices[device.type][device.brand].includes(device.model)) {
      devices[device.type][device.brand].push(device.model);
    }

    // Stocker l'URL ET le handle pour chaque modèle
    deviceUrls[device.model] = device.url || '#';
    deviceHandles[device.model] = device.handle || 'N/A';
  });

  const finderContainers = document.querySelectorAll('.repair-finder-container');

  finderContainers.forEach(container => {
    const typeSelector = container.querySelector('.device-type-selector');
    const brandSelector = container.querySelector('.device-brand-selector');
    const modelSelector = container.querySelector('.device-model-selector');
    const submitButton = container.querySelector('.repair-finder-submit');

    if (!typeSelector || !brandSelector || !modelSelector || !submitButton) {
      console.error('Repair Finder ERROR: Missing required elements in container.');
      return;
    }

    const deviceTypes = Object.keys(devices);
    populateSelector(typeSelector, deviceTypes);

    // Gestion du Type
    typeSelector.addEventListener('change', () => {
      const selectedType = typeSelector.value;
      resetSelector(brandSelector, 'Quelle marque ?');
      resetSelector(modelSelector, 'Quel modèle ?');
      submitButton.disabled = true;

      if (selectedType) {
        const brands = Object.keys(devices[selectedType]);
        populateSelector(brandSelector, brands);
        brandSelector.disabled = false;
      }
    });

    // Gestion de la Marque
    brandSelector.addEventListener('change', () => {
      const selectedType = typeSelector.value;
      const selectedBrand = brandSelector.value;
      resetSelector(modelSelector, 'Quel modèle ?');
      submitButton.disabled = true;

      if (selectedBrand) {
        const models = devices[selectedType][selectedBrand];
        populateSelector(modelSelector, models);
        modelSelector.disabled = false;
      }
    });

    // Gestion du Modèle
    modelSelector.addEventListener('change', () => {
      const selectedModel = modelSelector.value;

      if (selectedModel && deviceUrls[selectedModel]) {
        submitButton.disabled = false;
      } else {
        submitButton.disabled = true;
      }
    });

    // Gestion du bouton de soumission - REDIRECTION
    submitButton.addEventListener('click', () => {
      const selectedModel = modelSelector.value;

      if (selectedModel && deviceUrls[selectedModel]) {
        const targetUrl = deviceUrls[selectedModel];

        if (targetUrl && targetUrl !== '#') {
          // Vérifier si l'URL est valide avant de rediriger
          if (targetUrl.startsWith('/pages/') || targetUrl.startsWith('/a/metaobjects/')) {
            window.location.href = targetUrl;
          } else {
            console.error('❌ URL invalide détectée:', targetUrl);
            alert('Erreur : URL invalide générée.\n\nURL: ' + targetUrl + '\n\nVeuillez vérifier la configuration des méta-objets.');
          }
        } else {
          console.error('Repair Finder ERROR: Invalid URL for model:', selectedModel);
          console.error('Handle:', deviceHandles[selectedModel]);
          console.error('Available data:', allDevicesList.find(d => d.model === selectedModel));
          alert('Désolé, la page de ce modèle n\'est pas disponible.\n\nHandle du méta-objet : ' + deviceHandles[selectedModel] + '\n\nVeuillez vérifier que le template est bien assigné au méta-objet dans l\'admin Shopify.');
        }
      }
    });

    // Fonctions utilitaires
    function populateSelector(selector, options) {
      const defaultText = selector.options[0].text;
      selector.innerHTML = `<option value="" disabled selected>${defaultText}</option>`;
      options.sort().forEach(option => {
        const opt = document.createElement('option');
        opt.value = option;
        opt.textContent = option;
        selector.appendChild(opt);
      });
    }

    function resetSelector(selector, defaultText) {
      selector.innerHTML = `<option value="" disabled selected>${defaultText}</option>`;
      selector.disabled = true;
    }
  });
});
